import { createCachedSelector, path, prop, stringComposeKeySelectors } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { IClientLp } from '@cbridge-packages/lp-client';
import { makeLpSymbolCompositeId } from '../_helpers/makeLpSymbolCompositeId';
import { ISymbolLp, ISymbolLpIdentifier } from '../symbolLp.interface';
import { symbolLpStoreSelector } from '../symbolLp.selector';

export const symbolLpSelector = createCachedSelector(
  [
    path(symbolLpStoreSelector).data(),
    prop<ISymbolLpIdentifier>().lpId(),
    prop<ISymbolLpIdentifier>().name(),
  ],
  (symbolLpData, lpId, lpSymbolName) => {
    return symbolLpData[makeLpSymbolCompositeId(lpId, lpSymbolName)];
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: stringComposeKeySelectors(
    prop<{ lpId: IClientLp['lpId'] }>().lpId(),
    prop<{ name?: ISymbolLp['name'] }>().name(),
  ),
});
